module.exports = __webpack_public_path__ + "500776f94bfc59d71c967031c3903e56.pdf";